<template>
  <div id="hyra-ut-rum">

<h1>Hyra ut rum</h1>
<p>När man hyr ut rum får man inte sätta hyran hur högt man vill.</p>
  </div>
</template>

<script>
export default {
  name: 'hyra-ut-rum'
}
</script>
<!-- styling for the component -->
<style>

</style>



// WEBPACK FOOTER //
// Rum.vue?31341637